import loadable from "@loadable/component";
import { Routes, Route, useLocation } from "react-router-dom";
import Loading from "components/common/util/Loading";
import pMinDelay from "p-min-delay";
import { Layout } from "components/common/Layout";
import Home from "components/pages/Home";
const MIN_LOAD_DELAY = 0;

const ApplicationForm = loadable(async () =>
  pMinDelay(
    import("components/pages/ApplicationFormWithRoutes"),
    MIN_LOAD_DELAY
  )
);

const FacilityBooking = loadable(async () => pMinDelay(import("components/pages/facility-booking/FacilityBooking"), MIN_LOAD_DELAY))

const Centers = loadable(async () =>
  pMinDelay(import("components/pages/Centers"), MIN_LOAD_DELAY)
);
const ApplicationStatusV2 = loadable(async () =>
  pMinDelay(import("components/pages/ApplicationStatusV2"), MIN_LOAD_DELAY)
);

const NotFound = loadable(async () =>
  pMinDelay(import("components/pages/NotFound"), MIN_LOAD_DELAY)
);

const OneStateForm = loadable(async () =>
  pMinDelay(
    import("components/pages/application-form-with-routes/OneStateForm"),
    MIN_LOAD_DELAY
  )
);
const TwoCenterForm = loadable(async () =>
  pMinDelay(
    import("components/pages/application-form-with-routes/TwoCenterForm"),
    MIN_LOAD_DELAY
  )
);
const ThreeLocationForm = loadable(async () =>
  pMinDelay(
    import("components/pages/application-form-with-routes/ThreeLocationForm"),
    MIN_LOAD_DELAY
  )
);
const FourSpaceRequirementForm = loadable(async () =>
  pMinDelay(
    import(
      "components/pages/application-form-with-routes/FourSpaceRequirementForm"
    ),
    MIN_LOAD_DELAY
  )
);
const FiveContactDetailsForm = loadable(async () =>
  pMinDelay(
    import(
      "components/pages/application-form-with-routes/FiveContactDetailsForm"
    ),
    MIN_LOAD_DELAY
  )
);

const DebugRouter = ({ children }: { children: any }) => {
  const location = useLocation();
  if (process.env.NODE_ENV === "development") {
    console.log(
      `Route: ${location.pathname}${location.search}, State: ${JSON.stringify(
        location.state
      )}`
    );
  }

  return children;
};

const AppRoutes = () => (
  <DebugRouter>
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        {/* <Route path="/" element={<Home fallback={<Loading />} />} /> */}
        <Route path="/centers" element={<Centers fallback={<Loading />} />} />
        <Route path="/facility-booking" element={<FacilityBooking fallback={<Loading />} />} />
        <Route
          path="/application-status"
          element={<ApplicationStatusV2 fallback={<Loading />} />}
        />
        <Route
          path="/apply"
          element={<ApplicationForm fallback={<Loading />} />}
        >
          <Route
            index
            // path="select-state"
            element={<OneStateForm />}
          />
          <Route path="/apply/select-center" element={<TwoCenterForm />} />
          <Route
            path="/apply/select-building"  
            element={<ThreeLocationForm />}
          />
          <Route
            path="/apply/select-space"
            element={<FourSpaceRequirementForm />}
          />
          <Route
            path="/apply/contact-details"
            element={<FiveContactDetailsForm />}
          />
        </Route>
        <Route path="*" element={<NotFound fallback={<Loading />} />} />
      </Route>
    </Routes>
  </DebugRouter>
);
export default AppRoutes;
